<template>
    <div v-if="loaded">
    
        <form class="signup_form" @submit.prevent="$emit('next', formData)">
          <ul>
              <div class="part">
                  <li class="title">
                      <label>דירוגים מקצועיים (אופציונאלי)</label>
                      <span>ניתן לבחור יותר מאחד.עבור כל אחד, יש להזין קישור שמוביל לעמוד עם הדירוג</span>
                  </li>
                  <li>
                      <label>BDI דירוג</label>
                      <input type="text" v-model="formData.bdi_rating_link" placeholder="קישור לעמוד עם הדירוג">
                  </li>
                  <li>
                      <label>D&B דירוג</label>
                      <input type="text" v-model="formData.bd_rating_link" placeholder="קישור לעמוד עם הדירוג">
                  </li>
                  <li>
                      <label>דירוג מדד התחדשות עירונית</label>
                      <input type="text" v-model="formData.urban_renewal_rating_link" placeholder="קישור לעמוד עם הדירוג">
                  </li>
              </div>
              <div class="part">
                <li class="title">
                    <label>צוות המשרד</label>
                    <span>יש להוסיף איש צוות אחד לפחות המייצג את המשרד. פרטים אלו יוצגו <span class="pink">בכרטיס/בפרופיל</span> שלכם לבעלי דירות באתר המכרז השקוף</span>
                </li>
                <div class="gray_area" v-for="teamMember in formData.staff" :key="teamMember.id">
                  <div class="close" @click="deleteStaff(teamMember.id, )" v-if="formData.staff.length > 1" ><span class="icon close_icon"></span></div>
                  <li>
                      <label>שם מלא</label>
                      <input type="text" v-model="teamMember.name" >
                  </li>
                  <li>
                      <label>תפקיד</label>
                      <input type="text" v-model="teamMember.job" >
                  </li>
                  <li>
                    <label>תמונה</label>
                    <!-- <a class="btn_b">
                        <span>העלאת קובץ</span>
                        <span class="upload_icon icon"></span>
                    </a> -->
                    <GalleryInput :max="1" v-model="teamMember.pic" @onUpload="teamMember.pic =  $event.id" />
                    <span class="helper_text">מומלץ להעלות קובץ בגודל מינימלי של 300X200 פיקסלים</span>
                  </li>
                </div>
                <a class="btn_b text_s small" @click="formData.staff.push({ id: uniqueId(), name: '', job: '', pic: 0})">הוספת איש צוות</a>
              </div>
              <input v-if="state != 'edit'" type="submit" class="btn" value="סיום ושליחת פרטים">
          </ul>
        </form>
    </div>
</template>
  
  <script>
  import GalleryInput from '../GalleryInput.vue';

  export default {
    props: ["updatedData", "state"],
    components: {GalleryInput},
    data() {
        return {
            editMood: false,
            loaded:false,
            formData: {
                deletedStaffIds: [],
                staff: [ {id: this.uniqueId(), name: "", job: "", pic: 0} ],
                bdi_rating_link: '',
                bd_rating_link: '',
                urban_renewal_rating_link: '',
                step: 4
            }
        }
    },
    mounted() {
        if (this.updatedData) {

            for (const key in this.formData) {
                if (!this.editMood && this.updatedData[key]) this.editMood = true;
                if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
            this.loaded = true
        }
        if (this.formData.staff.length === 0) this.formData.staff.push({id: this.uniqueId(), name: "", job: "", pic: 0})
    },
    methods: {
        deleteStaff(id) {
            if (this.editMood) {
                this.formData.deletedStaffIds.push(id)
                // this.api({ action: 'application_signup/delete_staff', data: {id,  pid: this.updatedData.id}}, (data)=>{
                //     console.log(data.data);
                // })
            }
            this.formData.staff = this.formData.staff.filter(item => item.id !== id)
        }
    },
    watch: {
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    },
  }
  </script>
  
  <style>
  
  </style>